export default __webpack_public_path__ + "static/media/Lifesaving.5568bbca.jpg";